var _rect, _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIndicatorOk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    rx: 9,
    fill: "url(#indicator-ok_svg__paint0_linear)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.688 12.96a.716.716 0 01-.525-.232L4.538 9.92a.833.833 0 010-1.122c.29-.31.76-.31 1.05 0l2.1 2.245 4.725-5.051c.29-.31.76-.31 1.05 0 .29.31.29.812 0 1.122l-5.25 5.613a.717.717 0 01-.525.232z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "indicator-ok_svg__paint0_linear",
    x1: 9,
    y1: 0,
    x2: 9,
    y2: 18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8FDEA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6DCFAE"
  })))));
}

export default __webpack_public_path__ + "./fonts/indicator-ok.5d05b423f454cbdaa7e0a5900b247f78.svg";
export { SvgIndicatorOk as ReactComponent };